// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-restricted-imports */
// FIXME: remove this disable directive and fix the ESLint error(s)

import _ from "lodash"
import moment from "moment"
import Passenger from "@kiwicom/frontend-app/scripts/containers/mutable/Passenger"
import { serializeOldInsuranceName } from "@kiwicom/frontend-common/utils/isInsuranceAllowedForNationality"

export default function mapperPassengers(inputPassengers, handBagsAllowedForInfants) {
  const passengers = []
  _.forEach(inputPassengers, (passengerObj) => {
    // Map deprecated insurance names `travel_plus` and `travel_basic`
    const passengerInsurance = serializeOldInsuranceName(passengerObj.insurance_type)

    const firstAndMiddleName = passengerObj.firstname.split("|")

    const passenger = new Passenger({
      id: passengerObj.id,
      category: passengerObj.category,
      title: passengerObj.title.toLowerCase(),
      firstname: firstAndMiddleName[0],
      middlename: firstAndMiddleName[1] || "",
      lastname: passengerObj.lastname,
      birth: moment(passengerObj.birthday, "YYYY-MM-DD"),
      nationality: passengerObj.nationality.toLowerCase(),
      insurance: passengerInsurance,
      insurancePrice: Number(passengerObj.insurance_price || 0),

      priorityBoarding: passengerObj.priority_boarding || {},
    })

    if (passengerObj.travel_document) {
      passenger.document = {
        code: passengerObj.travel_document.cardno,
        expiration: passengerObj.travel_document.expiration
          ? moment.utc(passengerObj.travel_document.expiration * 1000).format("YYYY-MM-DD")
          : undefined,
      }
    }

    // FIXME: a method has been detected that possibly mutates the object, consider a more
    // functional approach (Ramda might help)

    passengers.push(passenger)
  })

  return passengers
}
